var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defaults, pickBy } from 'lodash';
import { createElement } from 'react';
export function isLazyComponent(obj) {
    return typeof (obj === null || obj === void 0 ? void 0 : obj.load) === 'function';
}
export function lazy(load) {
    return { load: load };
}
var Route = /** @class */ (function () {
    function Route(path, possiblyLazyView, options) {
        if (options === void 0) { options = {}; }
        this.path = path;
        this.possiblyLazyView = possiblyLazyView;
        this.options = options;
        this._view = null;
        this.options = defaults(options, {
            exact: true,
        });
    }
    Object.defineProperty(Route.prototype, "view", {
        get: function () {
            var _a;
            return isLazyComponent(this.possiblyLazyView)
                ? (_a = this._view) !== null && _a !== void 0 ? _a : NotLoaded
                : this.possiblyLazyView;
        },
        enumerable: false,
        configurable: true
    });
    Route.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isLazyComponent(this.possiblyLazyView) && !this._view)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.possiblyLazyView.load()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (this._view = result.default)];
                    case 2: return [2 /*return*/, this.view];
                }
            });
        });
    };
    Route.prototype.formatPath = function (params) {
        var keys = [];
        var url = this.path
            .replace(/\/:([^/]+)\?/g, function (_, key) {
            keys.push(key);
            return params[key] ? '/' + params[key] : '';
        })
            .replace(/:([^/]+)($|\/)/g, function (_, key, end) {
            keys.push(key);
            return params[key] + end;
        });
        var remainder = pickBy(params, function (value, key) {
            return value != null && !keys.includes(key);
        });
        if (!Object.keys(remainder).length || !URLSearchParams) {
            return url;
        }
        var search = new URLSearchParams(remainder);
        return url + '?' + search.toString();
    };
    return Route;
}());
export { Route };
var NotLoaded = function () {
    return createElement('div', { children: 'Lazy component not loaded' });
};
//# sourceMappingURL=Route.js.map